import React, { useState, useEffect } from 'react';
import Panel from 'Components/Panel/Panel'
import ExecuteAxios from 'Components/ExecuteAxios/ExecuteAxios';
import LoadingIndicator from 'Components/LoadingIndicator/LoadingIndicator';
import PanelListDefault from 'Components/PanelListDefault/PanelListDefault';
import ApplyAttributes from 'Components/ApplyAttributes/ApplyAttributes';
import ResetVariables from 'Components/ResetVariables/ResetVariables';
import RemoveIdsNotFound from 'Components/RemoveIdsNotFound/RemoveIdsNotFound';
import OptionsDataByAttributePath from 'Components/Options/optionsData/OptionsDataByAttributePath';
import ComboBox from 'Components/ComboBox/ComboBox';

const PeopleGroup = ({
    groupsIdsSelected
}) => {
    const [id, setId] = useState(null);
    const [employee, setEmployee] = useState(null);
    const [usernameUpdate, setUsernameUpdate] = useState(null);
    const [dtUpdate, setDtUpdate] = useState(false);

    const [inserting, setInserting] = useState(false);
    const [peopleIdsSelected, setPeopleIdsSelected] = useState([]);
    const [loadingPeoplePanel, setLoadingPeoplePanel] = useState(false);
    const [screenRecordsGrid, setPeopleRecordsGrid] = useState(null);
    const [attributesDetailPeoplePanel, setAttributesDetailItemPanel] = useState(null);
    const [selectedPeopleInsert, setSelectedPeopleInsert] = useState(null);
    const [sectors, setSectors] = useState(null);
    const sectorOptions = OptionsDataByAttributePath(sectors, ['description'], null, true)
    const [sectorIdSelected, setSectorIdSelected] = useState(null)

    const attributeList = [
        { name: "id", value: id, setter: setId },
        { name: "employee", value: employee, setter: setEmployee },
        { name: "usernameUpdate", value: usernameUpdate, setter: setUsernameUpdate },
        { name: "dtUpdate", value: dtUpdate, setter: setDtUpdate }
    ];

    const attributeListInsert = [
        { name: "id", value: id, setter: setId, allowsMultipleRecordsSelected: true },
        { name: "employee", value: employee, setter: setEmployee }
    ];

    // Grid de pessoas depende só do grupo; incluir/excluir já recarregam (postItem/deletePeople)
    useEffect(() => {
        reloadListPeople()
    }, [groupsIdsSelected])

    // Lista de funcionários para incluir só aparece no modo inclusão
    useEffect(() => {
        if (inserting) {
            fetchDataDetail();
        }
    }, [inserting, sectorIdSelected, groupsIdsSelected]);

    const itemPanelStyle = {
        display: 'flex',
        flexDirection: 'column',
        height: '83%',
    };

    useEffect(() => {
        if (!inserting) {
            setSelectedPeopleInsert([])
        }
    }, [inserting]);

    useEffect(() => {
        if (!groupsIdsSelected || groupsIdsSelected.length === 0) {
            setInserting(false)
        }
    }, [groupsIdsSelected]);

    async function reloadListPeople() {
        const parameters = {
            employeeGroupId: (groupsIdsSelected && groupsIdsSelected[0]) ? groupsIdsSelected[0] : 0
        }
        const people = await ExecuteAxios.api('get', `/selected-employees-group/grid/`, { params: parameters })
        setPeopleRecordsGrid(people);

        if (people) {
            RemoveIdsNotFound.remove(people, setPeopleIdsSelected, peopleIdsSelected)
        }
    }

    const fetchDataDetail = async () => {
        if (groupsIdsSelected && groupsIdsSelected[0]) {
            const parameters = {
                sectorId: sectorIdSelected || 0,
                employeeGroupId: groupsIdsSelected[0]
            }
            const item = await ExecuteAxios.api('get', `/selected-employees-group/employees-for-group/`, { params: parameters })
            if (item) {
                setAttributesDetailItemPanel(item)
                ApplyAttributes.applyAttributes(item, attributeList)
            }
        }
    };

    const detailAtributesStyle = {
        display: 'flex',
        flexDirection: 'column',
        margin: '10px 10px 5px 10px',
        width: '200px'
    };

    const getItemPanelListOrDetail = () => {
        if (!inserting) {
            return (
                <PanelListDefault
                    onUpdateIdSelected={setPeopleIdsSelected}
                    idsSelected={peopleIdsSelected}
                    data={screenRecordsGrid}
                    attributeList={attributeList}
                />
            )
        } else {
            return (
                <>
                    <div style={detailAtributesStyle}>
                        <label>Setor</label>
                        <ComboBox setAttribute={setSectorIdSelected}
                            optionsData={sectorOptions}
                            value={sectorIdSelected}
                            defaultValue={sectorIdSelected}
                        />
                    </div>
                    <PanelListDefault
                        onUpdateIdSelected={setSelectedPeopleInsert}
                        idsSelected={selectedPeopleInsert}
                        data={attributesDetailPeoplePanel}
                        attributeList={attributeListInsert}
                    />
                </>
            )
        }
    }

    async function postItem() {
        try {
            setLoadingPeoplePanel(true)
            const response = await ExecuteAxios.api('post', `/selected-employees-group/`, {
                employeeGroupId: groupsIdsSelected[0],
                selectedEmployees: selectedPeopleInsert
            });

            if (response) {
                await reloadListPeople()
            }
            return response;
        } finally {
            setLoadingPeoplePanel(false)
        }
    }

    useEffect(() => {
        const fetchData = async () => {
            const sectors = await ExecuteAxios.api('get', '/sector');
            setSectors(sectors);
        };

        fetchData();
    }, []);

    async function deletePeople() {
        try {
            setLoadingPeoplePanel(true)
            const response = await ExecuteAxios.api('delete', `/selected-employees-group/`, {
                params: { id: peopleIdsSelected[0] }
            });

            if (response) {
                await reloadListPeople()
            }
            return response
        } finally {
            setLoadingPeoplePanel(false)
        }
    }

    return (
        <div style={{
            display: 'flex', flexDirection: 'column', height: '100%', width: '100%'
        }}
            className={'main-modal two right'}
        >
            <LoadingIndicator loaded={!loadingPeoplePanel}>

                <Panel
                    style={itemPanelStyle}
                    titlePage={'Colaboradores por grupo'}
                    setInserting={setInserting}
                    inserting={inserting}
                    deleteFunction={deletePeople}
                    canDelete={deletePeople}
                    enableDelete={groupsIdsSelected && groupsIdsSelected.length === 1}
                    enableNewRecord={true}
                    canNewRecord={groupsIdsSelected && groupsIdsSelected.length === 1}
                    postFunction={postItem}
                    canViewCRUD={true}
                    readOnly={false}
                    recordsSelected={peopleIdsSelected}
                    peopleOnlyOneRecordCRUD={true}
                    resetVariables={() => { ResetVariables.resetVariables(attributeList) }}
                    dataListedAttributes={attributesDetailPeoplePanel}
                    attributeList={attributeList}
                    onUpdateIdSelected={setPeopleIdsSelected}
                >
                    {getItemPanelListOrDetail()}
                </Panel>
            </LoadingIndicator >
        </div>
    );

}
export default PeopleGroup;